import { render, staticRenderFns } from "./GPathSkillAdd.vue?vue&type=template&id=370a93ce&scoped=true"
import script from "./GPathSkillAdd.vue?vue&type=script&lang=js"
export * from "./GPathSkillAdd.vue?vue&type=script&lang=js"
import style0 from "./GPathSkillAdd.vue?vue&type=style&index=0&id=370a93ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370a93ce",
  null
  
)

export default component.exports